export default class InitManager {
    static createInitialCalendarState() {
        return {
            data: {
                staffs: [],
                spaces: [],
                events: [],
                hideEvents: [],
                hideStaffs: [],
                counter: {},
                presets: [],
            },
            selected: {
                staffs: [],
                spaces: [],
                category: null,
                event: null,
                mousePressed: false,
                load: 0,
                bookingAppend: null,
                preset: undefined,
                editEvents: 0,
            },
            params: {
                dateFocus: moment(new Date()).format('YYYY-MM-DD'),
                nbOfDay: 1,
                intervalXLevel: 0,
                intervalYLevel: 5,
                intervalMinutes: '30',
                showModal: false,
                modalMobile: false,
                newLogin: false,
                lastTime: '00:00',
                firstTime: '00:00',
                miniToolBar: false,
                smartResa: false,
                query: {},
            },
            move: {
                move_id: null,
                move_start: null,
                move_end: null,
                move_event: [],
                move_drag: false,
                move_events_drag: [],
                move_duration: [],
                move_fixed_duration: null,
                move_date: false,
                move_staff: {},
            },
            merge: {
                status: false,
                events: [],
            },
        }
    }
}
